import React, {useEffect, useState, useCallback} from 'react';
import {connect} from 'react-redux';
import {withRouter, useParams, Link} from 'react-router-dom';
import {Menu} from '../../utils/menu/Menu';
import {
  getcourseDataDeleteAction,
  getcourseDataEditAction,
  getcourseDataGetAction
} from '../../actions/getcourseDataAction';
import {formatErrors, UPDATE_TOGGLE_MENU, validateEmail} from '../../constants';
import {toast} from 'react-toastify';
import {InputProfile} from "../../utils/input/InputProfile";
import {ConfirmModal} from "../../utils/confirm/ConfirmModal";

const GetcourseDataItem = (props) => {
  const {getGetcourseDataItem, showMenu} = props;
  const {id} = useParams();
  const [item, setItem] = useState(null);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState(null);
  const [loading, setLoading] = useState(false);


  // get 
  const getGetcourseData = useCallback((id) => {
    getGetcourseDataItem(id).then((data) => {
      setItem(data);
      setForm({
        id: id,
        email: data.email,
        last_name: data.last_name || '',
        first_name: data.first_name || '',
        phone: data.phone || '',
        product_title: data.product_title || '',
        start_at: data.start_at || '',
        finish_at: data.finish_at || '',
        product_title_part2: data.product_title_part2 || '',
        start_at_part2: data.start_at_part2 || '',
        finish_at_part2: data.finish_at_part2 || '',
        product_title_part3: data.product_title_part3 || '',
        start_at_part3: data.start_at_part3 || '',
        finish_at_part3: data.finish_at_part3 || '',
      })
    }).catch(err => {
      toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });
  }, [getGetcourseDataItem]);

  const handleChangeForm = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setForm({...form, [name]: value});
    setErrors({...errors, [name]: name === 'email' && value.trim() === ''});
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (loading) {
      return false;
    }
    let errs = {};
    if (form.email === '' || validateEmail(form.email) !== true) {
      errs.email = true;
    }

    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      return;
    }

    setLoading(true);
    props.editGetcourseDataItem(form).then(() => {
      setLoading(false);
      getGetcourseData(id);
      toast.success('Изменения сохранены', {position: toast.POSITION.BOTTOM_RIGHT});
    }).catch((e) => {
      setLoading(false);
      toast.error(formatErrors([e.message]), {position: toast.POSITION.BOTTOM_RIGHT});
    });

  };

  const handleDelete = () => {
    return new Promise((resolve, reject) => {
      if (loading) {
        return resolve(false);
      }
      setLoading(true);
      props.deleteGetcourseDataItem(id).then(() => {
        setLoading(false);
        resolve(true);
        toast.success('Запись удалена', {position: toast.POSITION.BOTTOM_RIGHT});
        props.history.push('/getcourse_data');
      }).catch(err => {
        setLoading(false);
        toast.error(formatErrors([err.message]), {position: toast.POSITION.BOTTOM_RIGHT});
        reject(err);
      });
    });
  };

  useEffect(() => {
    if (id) {
      getGetcourseData(id);
    }
  }, [id, getGetcourseData]);

  useEffect(() => {
    showMenu();
  }, [showMenu]);

  return <div className="content">
    <Menu />

    <header className="header header--nav">
      <Link to={'/getcourse_data'} className="header__link">Пользователи getcourse</Link>
    </header>

    {form && <div className="profile">
      <form className="profile__wrapper" noValidate onSubmit={handleSubmit}>
        <span className="profile__heading">Пользователь getcourse</span>
        <h4 className="profile__name">{item.last_name} {item.first_name}</h4>

        <div className="profile__inner profile__inner--group">
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Фамилия"
                          name="last_name"
                          placeholder="Введите фамилию"
                          value={form.last_name}
                          error={errors.last_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="text"
                          title="Имя"
                          name="first_name"
                          placeholder="Введите имя"
                          value={form.first_name}
                          error={errors.first_name || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <InputProfile type="email"
                          title="Эл. почта"
                          name="email"
                          placeholder="Введите эл. почту"
                          value={form.email}
                          error={errors.email || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
                          
            <InputProfile type="text"
                          title="Телефон"
                          name="phone"
                          placeholder="Введите телефон"
                          value={form.phone}
                          error={errors.phone || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Название продукта"
                          name="product_title"
                          placeholder="Введите Название продукта"
                          value={form.product_title}
                          error={errors.product_title || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
            <InputProfile type="text"
                          title="Дата начала"
                          name="start_at"
                          placeholder="Введите Дата начала"
                          value={form.start_at}
                          error={errors.start_at || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>

            <InputProfile type="text"
                          title="Дата окончания"
                          name="finish_at"
                          placeholder="Введите Дата окончания"
                          value={form.finish_at}
                          error={errors.finish_at || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Название продукта part2"
                          name="product_title_part2"
                          placeholder="Введите Название продукта part2"
                          value={form.product_title_part2}
                          error={errors.product_title_part2 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
            <InputProfile type="text"
                          title="Дата начала part2"
                          name="start_at_part2"
                          placeholder="Введите Дата начала part2"
                          value={form.start_at_part2}
                          error={errors.start_at_part2 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
                          
            <InputProfile type="text"
                          title="Дата окончания part2"
                          name="finish_at_part2"
                          placeholder="Введите Дата окончания part2"
                          value={form.finish_at_part2}
                          error={errors.finish_at_part2 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
          <div className="profile__wrap">
            <InputProfile type="text"
                          title="Название продукта part3"
                          name="product_title_part3"
                          placeholder="Введите Название продукта part3"
                          value={form.product_title_part3}
                          error={errors.product_title_part3 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
                          
            <InputProfile type="text"
                          title="Дата начала part3"
                          name="start_at_part3"
                          placeholder="Введите Дата начала part3"
                          value={form.start_at_part3}
                          error={errors.start_at_part3 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
                          
            <InputProfile type="text"
                          title="Дата окончания part3"
                          name="finish_at_part3"
                          placeholder="Введите Дата окончания part3"
                          value={form.finish_at_part3}
                          error={errors.finish_at_part3 || false}
                          disabled={loading}
                          onChange={handleChangeForm}/>
          </div>
        </div>

        <button className="profile__btn btn">Сохранить</button>
        <ConfirmModal trigger={<span className="profile__heading profile__heading--bottom modal__link">Удалить запись</span>}
                      title={"Удалить запись?"}
                      handleOk={handleDelete}/>

      </form>
    </div>}
  </div>;
};

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
  return {
    getGetcourseDataItem(id) {
      return dispatch(getcourseDataGetAction(id));
    },
    deleteGetcourseDataItem(id) {
      return dispatch(getcourseDataDeleteAction(id));
    },
    editGetcourseDataItem(item) {
      return dispatch(getcourseDataEditAction(item));
    },
    showMenu() {
      dispatch({type: UPDATE_TOGGLE_MENU, menu: true})
    }
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GetcourseDataItem))
